"use strict";

exports.__esModule = true;
exports.TicketTypeRoutes = TicketTypeRoutes;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _System = require("../../../System");
var _TicketTypesScreen = require("../TicketTypesScreen");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Ticket Type Route
 */

function TicketTypeRoutes() {
  return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Routes, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: (0, _System.getScreenPath)("TicketTypes") + "/*",
    element: /*#__PURE__*/_react["default"].createElement(_TicketTypesScreen.TicketTypesScreen, null)
  }));
}